﻿var StickyStack = require('StickyStack');
import { debounce } from '../functions';
import bulmaCollapsible from '@creativebulma/bulma-collapsible';
import { createApp } from 'vue/dist/vue.esm-bundler';
const axios = require('axios');
import productionEvents from './Vue/eventsComponent.vue';

document.addEventListener('DOMContentLoaded', () => {
    // Only build the Vue instance if the targeted element is present.
    if (document.getElementById('production')) {
        const productionApp = createApp({
            components: {
                productionEvents
            },
            setup() {

            },
            data() {
                return {
                    dataApi: '',
                    dataSortKey: '',
                    dataSortDirection: '',
                    dataProductionId: null,
                    dataEventId: null,
                    loaded: false,
                    data: {},
                    items: [],
                    itemChildren: [],
                    description: '',
                    title: '',
                    subTitle: '',
                    genres: [],
                    cast: '',
                    crew: '',
                    detailUrl: '',
                    hasBreak: '',
                    prices: [],
                    normalPrice: [],
                    venueRoom: {},
                    event: null,
                    isReadMore: false,
                    hasWidgets: false,
                    hasCastCrew: false,
                    doOrderActive: false,
                    activityID: '',
                    shoppingcartUrl: '',
                    activeDate: '',
                    stickyStack: null
                }
            },
            // The computed property holds reactive properties for orderItems, filterItems and the queryModel are kept track of.
            computed: {
                orderItems() {
                    if (!this.dataSortKey && !this.dataSortDirection) return [];
                    return [
                        {
                            Key: this.dataSortKey,
                            Direction: this.dataSortDirection,
                        }
                    ]
                },
                filterItems() {
                    if (!this.dataProductionId) return [];
                    return [{
                        Key: 'providerId.keyword',
                        Values: [this.dataProductionId],
                        Operator: 'Eq'
                    }]
                },
                queryModel() {
                    return {
                        OrderItems: this.orderItems,
                        FilterItems: this.filterItems,
                    }
                },
            },
            methods: {
                // The fetchData method fetches and handles API data. 
                fetchData() {
                    axios
                        .post(this.dataApi, this.queryModel)
                        .then(response => {
                            if (response.status === 200) {
                                this.data = response.data;
                                if (this.data.items && this.data.items.length) {
                                    this.items = this.data.items;
                                    this.itemChildren = this.items.flatMap(obj => obj.children);
                                    if (this.items[0].name) this.title = this.items[0].name;
                                    if (this.items[0].subtitle) this.subTitle = this.items[0].subtitle;
                                    if (this.items[0].description) this.description = this.items[0].description;
                                    if (this.items[0].genres) this.genres = this.items[0].genres;
                                    this.hasBreak = this.items[0].hasBreak;
                                    if (this.items[0].prices) this.prices = this.items[0].prices;
                                    if (this.prices.length) this.normalPrice = this.prices.filter(price => price.priceTypeName === 'Normaal');
                                    if (this.items[0].productionLocation) this.venueRoom = this.items[0].productionLocation[0].name;
                                    if (this.items[0].cast) this.cast = this.items[0].cast;
                                    if (this.items[0].crew) this.crew = this.items[0].crew;
                                    if (this.items[0].detailUrl) this.detailUrl = this.items[0].detailUrl;
                                    this.hasCastCrew = this.cast.length || this.crew.length;
                                    if (this.activityID !== '') {
                                        let activeItem = this.items.find(event => event.availability.id === this.activityID);
                                        this.orderCallback(activeItem.availability, activeItem.orderButton, activeItem.firstStartDate, activeItem.firstEndDate);
                                    }
                                }
                                this.loaded = true;
                            }
                        })
                        .catch(error => console.log(error))
                },
                initDom() {
                    const $stickies = document.querySelectorAll('.sticky-order');
                    if (!this.stickyStack) {
                        this.stickyStack = new StickyStack(['.sticky-header']);
                    }
                },
                // Simple date string handler for date.
                toDateStr(dateString) {
                    return new Date(dateString).toLocaleDateString('nl-NL', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
                },
                // Simple short date string handler for date.
                toShortDateStr(dateString) {
                    return new Date(dateString).toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' }).replace('.', '');
                },
                // Simple date string handler for time.
                toTimeStr(dateString, endDateString) {
                    let startTime = new Date(dateString).toLocaleTimeString('nl-NL', { hour: 'numeric', minute: 'numeric' });
                    let endTime = endDateString ? new Date(endDateString).toLocaleTimeString('nl-NL', { hour: 'numeric', minute: 'numeric' }) : null;
                    return endTime ? startTime + ' - ' + endTime : startTime;
                },
                // Simple date string handler for date and time.
                todDateTimeStr(dateString) {
                    let date = new Date(dateString).toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
                    let time = new Date(dateString).toLocaleTimeString('nl-NL', { hour: 'numeric', minute: 'numeric' });
                    return date.replace('.', '') + ' | ' + time;
                },
                // Simple price int handler for outputting formatted price.
                toPrice(priceInt) {
                    return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(priceInt);
                },
                checkHeight() {
                    return this.$refs["content"].offsetHeight > 220
                },
                orderCallback(availability, orderButton, eventStartDate, eventEndDate) {
                    if (orderButton.isClickable) {
                        if (orderButton.orderUrlIsOverruled) {
                            location.href = orderButton.url;
                        } else {
                            let freeSeats = availability.freeSeats;
                            let id = availability.id;
                            this.activityID = availability.id;
                            this.activeDate = this.todDateTimeStr(eventStartDate);
                            if (eventEndDate) this.activeDate += ' - ' + this.toTimeStr(eventEndDate);
                            this.doOrderActive = false;
                            tww("ClearWidgets");
                            this.$nextTick(() => {
                                this.doOrderActive = true;
                                this.$nextTick(() => {
                                    if (freeSeats === 0) {
                                        tww('Waitinglist', id, 'orderTicketsContainer');
                                    } else {
                                        tww('Activity', id, 'orderTicketsContainer', 'ordercart', this.shoppingcartUrl);
                                    }
                                });
                            });
                        }
                    }
                },
                closeOrderFrame() {
                    if (typeof $shoppingCartCounter !== 'undefined' && $shoppingCartCounter !== null) {
                        tww('GetCartNrOfItems', this.NumberOfItemsCallBack);
                    }
                    this.doOrderActive = false;
                    this.activeDate = '';
                    this.activityID = '';
                },
                NumberOfItemsCallBack(data) {
                    if (data.NrOfItems !== undefined) {
                        if (data.NrOfItems === 0 || isNaN(data.NrOfItems)) {
                            $shoppingCartCounter.style.display = 'none';
                        } else {
                            $shoppingCartCounter.innerHTML = data.NrOfItems;
                            $shoppingCartCounter.style.display = 'flex';
                        }
                    }
                },
            },
            mounted() {
                // Set data props according to data attributes in HTML template.
                if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
                if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit);
                if (this.$el.dataset.sortkey) this.dataSortKey = this.$el.dataset.sortkey;
                if (this.$el.dataset.sortdirection) this.dataSortDirection = this.$el.dataset.sortdirection;
                if (this.$el.dataset.productionid) this.dataProductionId = this.$el.dataset.productionid;
                if (this.$el.dataset.activityid) this.activityID = this.$el.dataset.activityid;
                if (this.$el.dataset.shoppingcarturl) this.shoppingcartUrl = this.$el.dataset.shoppingcarturl;
                const $contentAfter = this.$el.parentElement.nextElementSibling;
                const $shoppingCartCounter = document.getElementById('shoppingCartCount');
                this.hasWidgets = (typeof $contentAfter !== 'undefined' || $contentAfter !== null) && $contentAfter.classList.contains('widget');
                // Initial data fetch.
                this.fetchData();
            },
            updated() {
                if (this.loaded) {
                    this.isReadMore = (this.hasWidgets || this.hasCastCrew) && this.checkHeight();
                    this.$nextTick(() => {
                        this.initDom();
                    });
                }
            }
        });

        // Mount the app on the targeted element.
        productionApp.mount('#production');
    }
});